"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconSmallerPlantFootprint = function IconSmallerPlantFootprint(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M33 20.958V5H10v20.58l-.005.258c-.076 1.923-.977 4.542-2.438 7.442l1.786.9.213-.427C11.086 30.633 12 27.814 12 25.58V11h14v-1h-.09v-.1H12.09v.1H12V7h19v13.78c-6.131.005-11.1 4.977-11.1 11.11 0 1.843.449 3.58 1.242 5.11H8v2h14.473c2.038 2.444 5.106 4 8.537 4 6.136 0 11.11-4.974 11.11-11.11 0-5.457-3.934-9.994-9.12-10.932M44 12v12h-2V14h-7v-2zM23 43v-2H12v2zm17.12-11.11a9.11 9.11 0 1 0-18.22 0 9.11 9.11 0 0 0 18.22 0m-8.62 5.575a3.5 3.5 0 0 0 3-3.465c0-1.722-1.03-3.904-2.263-5.832A29 29 0 0 0 31 26.392a29 29 0 0 0-1.237 1.776C28.53 30.096 27.5 32.278 27.5 34a3.5 3.5 0 0 0 3 3.465v-1.248l-2.234-2.084.682-.73L30.5 34.85V31h1v3.252l1.356-1.355.707.707-2.063 2.063zM30.037 25.18C28.584 27.063 26 30.855 26 34a5 5 0 0 0 10 0c0-3.145-2.584-6.937-4.037-8.82C31.395 24.444 31 24 31 24s-.395.444-.963 1.18",
    clipRule: "evenodd"
  })));
};

export { IconSmallerPlantFootprint, IconSmallerPlantFootprint as default };
